// extracted by mini-css-extract-plugin
module.exports = {"link_text":"style_link_text__Vz68O","link":"style_link__Abv7r","link_flex_justify_between":"style_link_flex_justify_between__Ot6Xm","arrow_icon":"style_arrow_icon__4xP9p"};